import React from "react";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";
import DMSPresenter from "./DMSPresenter";
import HeroDmsSection from "./components/HeroDmsSection";
import FooterSection from "./components/FooterSection";
import DmsSystemOverviewSection from "./components/DmsSystemOverviewSection";
import KeyFeaturesSection from "./components/KeyFeaturesSection";
import DmsInActionSection from "./components/DmsInActionSection";
import HighLevelArchitectureSection from "./components/HighLevelArchitectureSection";
import UASManagementSection from "./components/UASManagementSection";
import ImplementationServicesSection from "./components/ImplementationServicesSection";
import ImplementationServicesCTASection from "./components/ImplementationServicesCTASection";
import DemoRequestModal from "./components/DemoRequestModal";

import "./DMSPage.css";

class DMSPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new DMSPresenter();
  }

  render() {
    const heroContent = this.presenter.getHeroSectionContent();
    const footerText = this.presenter.getFooterContent().text;
    const overviewCards = this.presenter.getOverviewCards();
    const highLevelArchitecture =
      this.presenter.getHighLevelArchitectureContent();
    const uasContent = this.presenter.getUASManagementContent();
    const implementationContent =
      this.presenter.getImplementationServicesContent();

    return (
      <>
        <NavBar1 className="shadow-sm" />

        <HeroDmsSection heroContent={heroContent} />

        <DmsSystemOverviewSection overviewCards={overviewCards} />

        <KeyFeaturesSection features={this.presenter.getKeyFeatures()} />

        <DmsInActionSection image={this.presenter.getDmsInActionImage()} />

        <HighLevelArchitectureSection image={highLevelArchitecture.image} />

        <UASManagementSection
          title={uasContent.title}
          image={uasContent.image}
        />
        <ImplementationServicesSection
          title={implementationContent.title}
          image={implementationContent.image}
        />

        <ImplementationServicesCTASection />

        <FooterSection footerText={footerText} />

        <DemoRequestModal />
      </>
    );
  }
}

export default DMSPage;
